import { baseApi } from './baseApi';

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getConversionReport: builder.query({
      query: (params) => ({
        url: '/api/reports/conversion',
        params,
      }),
      providesTags: ['ConversionReport'],
      transformResponse: (response) => response.data,
    }),

    getCampaignVolumeAlerts: builder.query({
      query: (params) => ({
        url: '/api/reports/campaign-volume',
        params,
      }),
      providesTags: ['CampaignVolumeAlerts'],
      transformResponse: (response) => response.data,
    }),
  }),
});

export const { useGetConversionReportQuery, useGetCampaignVolumeAlertsQuery } = reportsApi;
